import { ToolHolderStep } from './tool-holder-step';
import { CamToolHolder } from './cam-tool-holder';
import { ToolHolderRebuildOption } from './tool-holder-rebuild-option';

export class ToolHolder {
  constructor(
    public hash?: string,
    public name?: string,
    public erp?: string,
    public stockNumber?: number,
    public toolHolderSteps?: ToolHolderStep[],
    public camToolHolders?: CamToolHolder[],
    public toolHolderRebuildOptions?: ToolHolderRebuildOption[]
  ) { }

  clone() {
    return new ToolHolder (
      this.hash,
      this.name,
      this.erp,
      this.stockNumber,
      this.toolHolderSteps,
      this.camToolHolders,
      this.toolHolderRebuildOptions
    );
  }

  get filterableData() {
    return `${ this.name } ${ this.erp }`.toLowerCase();
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/tool-holder.ts